import type { ComponentPropsWithoutRef } from 'react';
import ValuePickerWrapper from './ValuePickerWrapper';

interface InputWithValuePickerProps extends ComponentPropsWithoutRef<typeof ValuePickerWrapper> {
    placeholder: string;
    title: string;
}

const InputWithValuePicker = ({
    id,
    label,
    isRequired = false,
    testId,
    value,
    placeholder,
    title,
    container,
    description,
    onChangeAsValueReference,
}: InputWithValuePickerProps) => {
    return (
        <ValuePickerWrapper
            container={container}
            id={id}
            label={label}
            onChangeAsValueReference={onChangeAsValueReference}
            testId={testId}
            value={value}
            description={description}
            isRequired={isRequired}
        >
            <input
                placeholder={placeholder}
                className="form-control"
                id={id}
                type="text"
                value={typeof value === 'string' ? value : ''}
                onChange={({ target: { value } }) => {
                    onChangeAsValueReference(value);
                }}
                title={title}
                required={isRequired}
            />
        </ValuePickerWrapper>
    );
};

export default InputWithValuePicker;
